export default __webpack_public_path__ + "static/media/girlImg.87510e5f.png";